




























































































































































	import Vue from 'vue';
	import weaponList from '@/assets/TPweapons.json';
	import equipmentList from '@/assets/TPequipment.json';

  export default Vue.extend({
    data () {
      return {
				raritySlider: 7,
				priceSlider: 100,
				blackMarket: "TP",
				search: '',
      }
		},
		methods: {
			closeAll () {
				Object.keys(this.$refs).forEach(k => {
						if (this.$refs[k] && this.$refs[k].$attrs['data-open']) {
								this.$refs[k].$el.click()
						}
				})
			},
			openAll () {
				Object.keys(this.$refs).forEach(k => {
						if (this.$refs[k] && !this.$refs[k].$attrs['data-open']) {
								this.$refs[k].$el.click()
						}
				})
			},
			parseRare (item) {
				if (item.Rarity === 1) return "Common";
				else if (item.illegal) return `Illegal(${item.Rarity})`;
        else return `Rare(${item.Rarity})`;
      },
		},
    computed: {
      weaponHeaders () {
        return [
          {
            text: 'Item',
            align: 'start',
            sortable: false,
            value: 'Item',
					},
					{ text: 'RngS', value: 'RngS' },
					{ text: 'RngL', value: 'RngL' },
					{ text: 'AccS', value: 'AccS' },
					{ text: 'AccL', value: 'AccL' },
					{ text: 'Str', value: 'Str' },
					{ text: 'AP', value: 'AP' },
					{ text: 'D', value: 'D' },
					{ text: 'Ammo', value: 'Ammo' },
					{ text: 'Traits', sortable: false, value: 'Traits' },
          {
            text: 'Rarity',
            value: 'Rarity',
            filter: value => {
              if (!this.raritySlider) return true
              return value <= parseInt(this.raritySlider)
            },
          },
          { 
						text: 'Price',
						value: 'Price',
						filter: value => {
              if (!this.priceSlider) return true
              return value <= parseInt(this.priceSlider)
            },
					},
        ]
			},
			equipmentHeaders () {
        return [
          {
            text: 'Item',
            align: 'start',
            sortable: false,
            value: 'Item',

					},
					{ text: 'Info', value: 'Info' },
          {
            text: 'Rarity',
            value: 'Rarity',
            filter: value => {
              if (!this.raritySlider) return true
              return value <= parseInt(this.raritySlider)
            },
          },
          { 
						text: 'Price',
						value: 'Price',
						filter: value => {
              if (!this.priceSlider) return true
              return value <= parseInt(this.priceSlider)
            },
					},
        ]
      },
			filterBlackMarketWeapons () {
        if (this.blackMarket == "BM") {
          return weaponList.filter((i) => {
            return i.black == true;
          })
				} else {
					return weaponList.filter((i) => {
            return i.black == false;
          })
				}
			},
			filterBlackMarketEquipment () {
        if (this.blackMarket == "BM") {
          return equipmentList.filter((i) => {
            return i.black == true;
          })
				} else {
					return equipmentList.filter((i) => {
            return i.black == false;
          })
				}
      }
    }
  })
